var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_45_617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.41933 3.87695C9.25668 3.87695 10.0597 4.20959 10.6518 4.80169C11.2439 5.39379 11.5766 6.19684 11.5766 7.03419V10.7176H9.47174V7.03419C9.47174 6.75508 9.36086 6.48739 9.1635 6.29003C8.96613 6.09266 8.69844 5.98178 8.41933 5.98178C8.14021 5.98178 7.87252 6.09266 7.67516 6.29003C7.47779 6.48739 7.36691 6.75508 7.36691 7.03419V10.7176H5.26208V7.03419C5.26208 6.19684 5.59472 5.39379 6.18682 4.80169C6.77892 4.20959 7.58197 3.87695 8.41933 3.87695Z",
    stroke: "#D6B893",
    strokeWidth: 1.05241,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.15756 4.40332H1.05273V10.7178H3.15756V4.40332Z",
    stroke: "#D6B893",
    strokeWidth: 1.05241,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.10515 2.82455C2.68638 2.82455 3.15756 2.35337 3.15756 1.77214C3.15756 1.19091 2.68638 0.719727 2.10515 0.719727C1.52392 0.719727 1.05273 1.19091 1.05273 1.77214C1.05273 2.35337 1.52392 2.82455 2.10515 2.82455Z",
    stroke: "#D6B893",
    strokeWidth: 1.05241,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45_617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.629,
    height: 12.629,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linked in.502775cacd7036f4d501eca5a7113093.svg";
export { ForwardRef as ReactComponent };